immutable = require 'seamless-immutable'
moment = require 'moment'
ObserveStudentsComponent = require '../components/ObserveStudents'
React = require 'react'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'
{ doFlash } = require '../actions/flash'
{
	beginObservation,
	createObservationCycle,
	createStudentObservation,
	createStudentObservationEvent,
	endObservation,
	endObservationCycle,
	endStudentObservations,
	pauseStudentObservations,
	unpauseStudentObservations
} = require '../actions/observations'
{
	BEHAVIOR_TYPE_IDS: {
		ON_TASK
		OFF_TASK
	}
	CONTEXT_IDS: {
		WHOLE_CLASS
		SMALL_GROUP
		INDIV
	}
	GRADE_LEVEL_IDS: {
		KINDERGARTEN
		PRE_K
	}
	MANAGEMENT_IDS: {
		TEACHER
		PEERS
		ALONE
	}
	INSTRUCTION_TYPE_IDS: {
		MEANING_FOCUSED
		CODE_FOCUSED
		PLAY
		NUMBER_OPERATIONS
		ALGEBRA
		GEOMETRY
		APPLIED
		OPERATIONS
	}
	OBSERVATION_SUBJECT_IDS: {
		NON_INSTRUCTION
		ART
		LITERACY
		MATH
		MUSIC
		OTHER
		SCIENCE
		SOCIAL_STUDIES
		MEAL_TIME
		SOCIOEMOTIONAL_LEARNING
		OFF_CAMERA
	}
	OBSERVATION_PART_TYPE_IDS: {
		STUDENT
	}
} = require '../lib/commonIds'

class ObserveStudentsContainer extends Component
	@propTypes:
		createStudentObservation: PropTypes.func.isRequired
		createStudentObservationEvent: PropTypes.func.isRequired
		currentCycleNumber: PropTypes.number.isRequired
		endObservationCycle: PropTypes.func.isRequired
		gradeLevelId: PropTypes.number.isRequired
		navigationWarningModal: PropTypes.node
		numberOfCycles: PropTypes.number.isRequired
		# startTimerAt is a moment duration, indicating how much of the cycle has already been observed, e.g. 2:34 out of 5:00.
		startTimerAt: PropTypes.object.isRequired
		# studentMinutes is a moment duration.
		studentMinutes: PropTypes.object.isRequired
		students: PropTypes.arrayOf(PropTypes.object).isRequired
		toggleStudentObservation: PropTypes.func.isRequired

	constructor: (props) ->
		@state = {
			data: immutable({
				confirmingDone: false
				isTimerRunning: false
				isTimerUp: false
				timer: props.startTimerAt.asMilliseconds()
			})
		}

		@timerLastPausedAt = null

	timerInterval: null

	componentWillMount: =>
		if @props.observation.observation_cycles
			if !!_.last(@props.observation.observation_cycles).ended_at
				@createObservationCycle()
		else
			@createObservationCycle()

	componentDidMount: =>
		{ startTimerAt } = @props
		now = moment.utc()
		@timerLastPausedAt = now
		@clockStartedAt = moment.utc(@timerLastPausedAt).subtract(startTimerAt)
		@startTimer()

	componentWillUnmount: =>
		clearInterval(@timerInterval)
		@props.endObservationCycle()

	createObservationCycle: =>
		@props.createObservationCycle({
			started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
			observation_part_type_id: STUDENT,
			cycle_number: @props.currentCycleNumber,
			done: false
		})

	recordStudentEvent: (studentId, eventId) =>
		@props.createStudentObservationEvent(studentId, {
			created_at: moment.utc().format('YYYY-MM-DD HH:mm:ss')
			student_event_type_id: eventId,
			cycle_number: @props.currentCycleNumber,
			time_on_clock: @getTimerAsString()
		})

	recordEventForAllStudents: (eventId) =>
		@props.students.map (student) =>
			@recordStudentEvent(student.id, eventId)

	getMostRecentStudentObservation: (studentId) =>
		if (@props.observation.student_observations)
			studentObservations = @props.observation.student_observations.filter (studentObservation) =>
				studentObservation?.student_id == studentId

			if studentObservations.length
				return _.last(studentObservations)
			else
				return null
		else
			return null

	recordStudentObservation: (studentId, updatedKey = null, value = null) =>
		mostRecentObservation = @getMostRecentStudentObservation(studentId)

		if (mostRecentObservation)
			observationData = {
				student_id: studentId,
				observation_subject_id: mostRecentObservation.observation_subject_id,
				observation_context_id: mostRecentObservation.observation_context_id,
				observation_instruction_type_id: mostRecentObservation.observation_instruction_type_id,
				started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
				student_behavior_type_id: mostRecentObservation.student_behavior_type_id,
				observation_management_id: mostRecentObservation.observation_management_id,
				cycle_number: @props.currentCycleNumber,
				time_on_clock: @getTimerAsString()
			}
		else
			observationData = {
				student_id: studentId,
				observation_subject_id: NON_INSTRUCTION,
				observation_context_id: WHOLE_CLASS,
				observation_instruction_type_id: MEANING_FOCUSED,
				started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
				student_behavior_type_id: ON_TASK,
				observation_management_id: TEACHER,
				cycle_number: @props.currentCycleNumber,
				time_on_clock: @getTimerAsString()
			}

		if updatedKey != null
			observationData[updatedKey] = value

			switch updatedKey
				when 'observation_context_id'
					if value == WHOLE_CLASS
						observationData.observation_management_id = TEACHER
				when 'observation_management_id'
					if value == PEERS
						observationData.observation_context_id = SMALL_GROUP
					else if value == ALONE
						observationData.observation_context_id = INDIV
				when 'observation_subject_id'
					if value == LITERACY
						observationData.observation_instruction_type_id = CODE_FOCUSED
					else if value == MATH
						observationData.observation_instruction_type_id = NUMBER_OPERATIONS
					else
						observationData.observation_instruction_type_id = null

						if value == NON_INSTRUCTION
							observationData.observation_management_id = TEACHER

		@props.createStudentObservation(observationData)

	setContextToWholeClass: =>
		@props.students.map (student) =>
			@recordStudentObservation(student.id, 'observation_context_id', WHOLE_CLASS)

	getTimerAsString: =>
		if @state.data.timer
			return moment.duration(@state.data.timer).format('hh:mm:ss', { trim: false })
		else
			return '00:00:00'

	done: =>
		@props.endStudentObservations()
		@props.endObservation()
		@props.toggleStudentObservation()

	startTimer: =>
		@props.beginObservation()
		now = moment.utc()

		if @timerLastPausedAt
			referenceStartTime = moment.duration(@timerLastPausedAt.diff(@clockStartedAt))
		else
			referenceStartTime = moment.duration(0)

		@clockStartedAt = moment.utc(now).subtract(referenceStartTime)
		@cycleStartedAt = now

		@timerInterval = setInterval =>
			timer = moment.utc().diff(@clockStartedAt)
			@setState data: @state.data.set 'timer', timer
			localStorage.setItem('currentCycleElapsedSeconds', Math.round(timer / 1000))

			if moment.duration(timer).asMinutes() >= @props.studentMinutes.asMinutes()
				@setState({
					data: @state.data.merge({
						confirmingDone: false
						isTimerUp: true
					})
				})

				@stopTimer()
		, 1000

		@setState({ data: @state.data.set('isTimerRunning', true) })

	stopTimer: =>
		{ data } = @state
		clearInterval(@timerInterval)
		@setState({ data: data.set('isTimerRunning', false) })
		@timerLastPausedAt = moment.utc()
		@props.endObservation()

	toggleTimer: =>
		{ data: { isTimerRunning } } = @state

		if isTimerRunning
			@stopTimer()
			@recordEventForAllStudents(8)
			@props.pauseStudentObservations()
		else
			@startTimer()
			@props.unpauseStudentObservations()
			@recordEventForAllStudents(9)

	handleUndo: =>
		@recordEventForAllStudents(13)

	render: =>
		React.createElement(ObserveStudentsComponent, { \
			"askDone": ( => @setState({ data: @state.data.set('confirmingDone', true) }) ),  \
			"cancelDone": ( => @setState({ data: @state.data.set('confirmingDone', false) }) ),  \
			"confirmingDone": ( @state.data.confirmingDone ),  \
			"currentCycleNumber": ( @props.currentCycleNumber ),  \
			"done": ( if @state.data.isTimerUp then @props.toggleStudentObservation else @done ),  \
			"getMostRecentStudentObservation": ( @getMostRecentStudentObservation ),  \
			"gradeLevelId": ( @props.gradeLevelId ),  \
			"handleUndo": ( @handleUndo ),  \
			"isTimerRunning": ( @state.data.isTimerRunning ),  \
			"isTimerUp": ( @state.data.isTimerUp ),  \
			"navigationWarningModal": ( @props.navigationWarningModal ),  \
			"numberOfCycles": ( @props.numberOfCycles ),  \
			"recordStudentEvent": ( @recordStudentEvent ),  \
			"recordStudentObservation": ( @recordStudentObservation ),  \
			"setContextToWholeClass": ( @setContextToWholeClass ),  \
			"studentMinutes": ( @props.studentMinutes ),  \
			"students": ( @props.students ),  \
			"timer": ( @getTimerAsString() ),  \
			"toggleTimer": ( @toggleTimer )
		})

mapStateToProps = (state) ->
	return {
		observation: state.observations.current
	}

mapDispatchToProps = {
	beginObservation
	createObservationCycle
	createStudentObservation
	createStudentObservationEvent
	doFlash
	endObservation
	endObservationCycle
	endStudentObservations,
	pauseStudentObservations,
	unpauseStudentObservations
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObserveStudentsContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/ObserveStudents.cjsx